import { loadAxios } from '../../utils/loadAxios'

// Declared here rather than imported from src/constants: a module shared with the funnel entry
// would be split into its own chunk, and the partner-embedded smartadvisor entry must stay one
// file. The match-screen test asserts this key matches the funnel's constant.
export const ROUTING_FLAG_KEY = 'fsm-963_funnel_use_lead_engine_feature_flag_check_endpoint'
const ROUTING_FLAG = { flagKey: ROUTING_FLAG_KEY }
// A flag read that hangs blocks the match screen; past this bound the read resolves to its default.
const FEATURE_FLAG_REQUEST_TIMEOUT_MS = 10000

let routingRead: Promise<string> | null = null

/** Test seam: forgets the page load's routing decision. */
export const clearFeatureFlagCache = (): void => {
  routingRead = null
}

const postFeatureFlagCheck = async (url: string, flagKey: string, sessionUUID: string): Promise<boolean> => {
  const axios = await loadAxios()
  const response = await axios({
    url,
    method: 'POST',
    timeout: FEATURE_FLAG_REQUEST_TIMEOUT_MS,
    data: {
      flagKey,
      sessionUUID,
      meta: {}
    },
    headers: {
      'Content-Type': 'application/json',
      'X-Referer': window.location.href
    }
  })
  return !!response.data?.enabled
}

// Picks the backend that serves this page load's flag reads, as the funnel's resolver does: the
// routing flag is always read from funnel-backend, once per page load; a failed read means
// funnel-backend.
// TODO(FSM-963): once lead-engine serves feature-flag-check for every session, point
// featureFlagCheckUrl at lead-engine and remove this resolver and leadEngineFeatureFlagCheckUrl.
const resolveFeatureFlagCheckUrl = (sessionUUID: string): Promise<string> => {
  if (!leadEngineFeatureFlagCheckUrl) return Promise.resolve(featureFlagCheckUrl)
  if (!routingRead) {
    routingRead = postFeatureFlagCheck(featureFlagCheckUrl, ROUTING_FLAG.flagKey, sessionUUID)
      .then((enabled) => (enabled ? leadEngineFeatureFlagCheckUrl : featureFlagCheckUrl))
      .catch(() => featureFlagCheckUrl)
  }
  return routingRead
}

export const evaluateFeatureFlag = async (
  flagKey: string,
  sessionUUID: string,
  defaultValue = false
): Promise<boolean> => {
  if (!featureFlagCheckUrl) return defaultValue

  try {
    // The routing flag is only ever read from funnel-backend, the backend known before any decision.
    const url = flagKey === ROUTING_FLAG.flagKey ? featureFlagCheckUrl : await resolveFeatureFlagCheckUrl(sessionUUID)
    return await postFeatureFlagCheck(url, flagKey, sessionUUID)
  } catch {
    return defaultValue
  }
}
